import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../../helpers/helper';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { QuestionService } from '../../../services/question.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { AlertasModales } from '../../../helpers/alertasModales';

@Component({
  selector: 'app-restablecer-contrasena',
  templateUrl: './restablecer-contrasena.component.html',
  styleUrls: ['./restablecer-contrasena.component.css'],
  providers:  [QuestionService]
})
export class RestablecerContrasenaComponent implements OnInit {
  formGroup: FormGroup;
  loading = false;

  constructor(public activeModal: NgbActiveModal,
    public helper: Helper,
    private empleadoService: EmpleadosServicio,
  ) {
    this.formGroup = new FormGroup({
      usuario: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
  }

  guardar() {
    if (this.formGroup.valid) {
      this.loading = true;
      this.empleadoService.restablecerPassword(this.formGroup.value)
      .subscribe(() => {
        this.activeModal.close('ok');
      }, err => {
        this.loading = false;
        this.activeModal.close(err);
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/restablecer-contrasena/restablecer-contrasena.component.ts